"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskBoardStatusAction = void 0;
const react_1 = __importStar(require("react"));
const user_ui_1 = require("@sierralabs/user-ui");
const useUpdateTask_1 = require("../hooks/useUpdateTask");
const Task_machine_1 = require("../Task.machine");
const TaskBoardStatusAction = props => {
    const { task, target, taskEntity, findEventName, setIsLoading, onCancel, onChange, onError } = props;
    const onCancelRef = (0, react_1.useRef)(onCancel);
    const onChangeRef = (0, react_1.useRef)(onChange);
    const onErrorRef = (0, react_1.useRef)(onError);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const user = (0, user_ui_1.useUserContext)().user;
    const { machine, stateNode, render, canTransition, handleTransition } = (0, Task_machine_1.useGetWorkflowMachineState)(task);
    const { data: updatedTask, isLoading, error, updateTask } = (0, useUpdateTask_1.useUpdateTask)(task.id);
    const event = (0, react_1.useMemo)(() => {
        var _a;
        const eventName = findEventName(task.status, target);
        return (_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.events) === null || _a === void 0 ? void 0 : _a.find(event => event.name === eventName);
    }, [stateNode, target, task.status, findEventName]);
    const context = (0, react_1.useMemo)(() => {
        return { task, taskEntity, user };
    }, [task, taskEntity, user]);
    const cancel = (0, react_1.useCallback)(() => {
        var _a;
        (_a = onCancelRef.current) === null || _a === void 0 ? void 0 : _a.call(onCancelRef);
    }, []);
    const executeTransition = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        // skip without cancel
        if (!event || !machine || !stateNode) {
            return;
        }
        if (!(yield canTransition(event, context))) {
            cancel();
            return;
        }
        // do transition
        const newState = yield handleTransition(event, context);
        if (!newState || newState.path === stateNode.path) {
            cancel();
            return;
        }
        updateTask({
            status: newState.path,
            event: event.toJson(),
            reason: newState.context.reason,
            subTaskUserIds: newState.context.subTaskUserIds,
            clearFieldItems: newState.context.clearFieldItems
        });
    }), [
        context,
        event,
        machine,
        stateNode,
        canTransition,
        cancel,
        handleTransition,
        updateTask
    ]);
    (0, react_1.useEffect)(() => {
        onCancelRef.current = onCancel;
    }, [onCancel]);
    (0, react_1.useEffect)(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        onErrorRef.current = onError;
    }, [onError]);
    (0, react_1.useEffect)(() => {
        setIsLoading(task.id, isLoading);
    }, [isLoading, task.id, setIsLoading]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedTask) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedTask);
        }
    }, [updatedTask]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (error) {
            (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, error);
        }
    }, [error]);
    (0, react_1.useEffect)(() => {
        executeTransition();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event, taskEntity]);
    return react_1.default.createElement(react_1.default.Fragment, null, render);
};
exports.TaskBoardStatusAction = TaskBoardStatusAction;
exports.default = exports.TaskBoardStatusAction;
//# sourceMappingURL=TaskBoardStatusAction.js.map